import React from "react";
import ChipSelector, { ChipOption } from "../../../common/form/ChipSelect/ChipSelector";
import CustomText from "../../../common/general/CustomText/CustomText";
import { colors, spacing } from "../../../../styles/design-system";

import { StyleSheet, View } from "react-native";

interface Value {
  skillsToImprove: string[];
  learningStyles: string[];
}

interface Props {
  value: Value;
  onChange: (v: Value) => void;
}

const skillOptions: ChipOption[] = [
  { key: "problem_solving", value: "Problem Solving" },
  { key: "exam_prep", value: "Exam Prep" },
  { key: "writing", value: "Writing" },
  { key: "coding", value: "Coding" },
  { key: "memorization", value: "Memorization" },
  { key: "time_management", value: "Time Management" },
];

const learningMethodOptions: ChipOption[] = [
  { key: "practice_problems", value: "Practice Problems" },
  { key: "step_by_step", value: "Step-by-Step Explanations" },
  { key: "visual_examples", value: "Visual Examples" },
  { key: "quick_summaries", value: "Quick Summaries" },
];

export default function LearningPreferencesEditor({ value, onChange }: Props) {
  return (
    <View style={styles.container}>
      <CustomText
        style={{ color: colors.grey[500], marginBottom: spacing.xxs }}
        useTranslationText={false}
        text="WHAT DO YOU WANT TO GET BETTER AT?"
        size="xs"
        weight="bold"
      />
      <ChipSelector
        options={skillOptions}
        selectedKeys={value?.skillsToImprove ?? []}
        onSelectionChange={(v) => onChange({ ...value, skillsToImprove: v })}
        multiSelect
      />

      <CustomText
        style={{ color: colors.grey[500], marginBottom: spacing.xxs }}
        useTranslationText={false}
        text="HOW DO YOU LEARN BEST?"
        size="xs"
        weight="bold"
      />

      <ChipSelector
        options={learningMethodOptions}
        selectedKeys={value?.learningStyles ?? []}
        onSelectionChange={(v) => onChange({ ...value, learningStyles: v })}
        multiSelect
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    gap: spacing.md,
  },
});
